import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import DashboardLayout from "../../containers/DashboardLayout";
import Container from "../../components/Container";
import ManageEventSidebar from "../../containers/Sidebar/ManageEventSidebar";
import EventProfileSidebar from "../../containers/Sidebar/EventProfileSidebar";
import EventProfileSidebarItem from "../../containers/Sidebar/EventProfileSidebarNav";
import ManageProfileHeader from '../../containers/Header/ManageProfileHeader';
import { GetEventProfileById } from "../../revampCRUD/eventProfile.curd";
import customToast from "../../components/common/basic/Toast";

// Components for specific routes
import OrganiserDetails from "./EventProfileDetails/OrganiserDetails";
import Team from "./EventProfileDetails/Team";
import WhiteLabel from "./EventProfileDetails/WhiteLabel";
import Page404 from "../../pages/Page404";
import AssociatedEvents from "./EventProfileDetails/AssociatedEvents";
import { toggleBodyScroll } from "../../services/util";
import { useParams } from "react-router-dom";

const EventProfileDetailsPage = (props) => {
    const location = useLocation();
    const [expandedSection, setExpandedSection] = useState(true);
    const [manageProfileDetails, setManageProfileDetails] = useState({});

    // Match heading based on path
    const sidebarItems = EventProfileSidebarItem();
    const matchedItem = sidebarItems.find(item =>
        location.pathname.startsWith(item.path)
    );
    const pageHeading = matchedItem?.label || "";
    const { profileId } = useParams();

    // Map paths to components
    const routeToComponent = {
        [`/event-profile/${profileId}/organizer-details`]: OrganiserDetails,
        [`/event-profile/${profileId}/team`]: Team,
        [`/event-profile/${profileId}/white-label`]: WhiteLabel,
        [`/event-profile/${profileId}/white-label/branding`]: WhiteLabel,
        [`/event-profile/${profileId}/white-label/customization`]: WhiteLabel,
        [`/event-profile/${profileId}/associated-events`]: AssociatedEvents
    };

    // Fetch event profile details by ID
    const fetchEventProfileDetails = async () => {
        try {
            const response = await GetEventProfileById(profileId);
            if (response && response.data) {
                setManageProfileDetails(response.data.event_profile);
            }
        } catch (error) {
            customToast.error("Something went wrong");
        }
    };
    useEffect(() => {
        fetchEventProfileDetails();
    }, [profileId]);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            toggleBodyScroll(expandedSection);
            if (!expandedSection) {
                toggleBodyScroll(false);
            }
        }
    }, [expandedSection]);

    return (
        <DashboardLayout props={props} setExpandedSection={setExpandedSection} expandedSection={expandedSection}>
            <Container className="manage_events_container m-0">
                <div className="event-profile-wrapper">
                    {/* Main Sidebar */}

                    {/* Main Sidebar */}
                    <div className={`sidebar-main${expandedSection ? " sidebar-visible" : ""}`}>
                        <ManageEventSidebar setExpandedSection={setExpandedSection} expandedSection={expandedSection} />
                    </div>
                    {/* Overlay for mobile */}
                    {expandedSection && (
                        <div
                            className="sidebar-overlay"
                            onClick={() => setExpandedSection(false)}
                        />
                    )}

                    {/* Sub-sidebar and Content */}
                    <div className="event-profile-content-wrapper">
                        {/* Sub-sidebar */}
                        <div className={`sidebar-sub ${expandedSection ? "sidebar-visible" : ""}`}>
                            <EventProfileSidebar setExpandedSection={setExpandedSection} expandedSection={expandedSection} />
                        </div>

                        {/* Main content */}
                        <div className="event-profile-main-content">
                            <ManageProfileHeader manageProfileDetails={manageProfileDetails} fetchEventProfileDetails={fetchEventProfileDetails} />

                            <Switch>
                                {sidebarItems.map(({ path }, idx) => {
                                    const Component = routeToComponent[path] || (() => <Page404 />);
                                    return <Route exact={false} path={path} component={Component} key={idx} />;
                                })}

                                <Route exact path="/">
                                    <Redirect to="/manage-events" />
                                </Route>
                            </Switch>
                        </div>
                    </div>
                </div>
            </Container>

            <style>{`
                .sidebar-overlay {
                    display: none;
                }
                .event-profile-wrapper {
                    display: flex;
                    min-height: 100vh;
                }

                .sidebar-main {
                    flex-shrink: 0;
                }

                .event-profile-content-wrapper {
                    display: flex;
                    flex: 1;
                }

                .sidebar-sub {
                    width: 240px;
                    background-color: #fff;
                    border-right: 1px solid #e0e0e0;
                    flex-shrink: 0;
                }

                .event-profile-main-content {
                    flex: 1;
                    padding: 20px 24px 24px 24px;
                    background-color: #f4f7fd;
                }

                .event-profile-heading {
                    font-size: 20px;
                    font-weight: 700;
                    color: #183b56;
                    margin-bottom: 18px;
                    margin-left: 4px;
                }

                @media (max-width: 768px) {
                 .sidebar-main {
                    position: fixed;
                    left: 0;
                    height: 100%;
                    transform: translateX(-100%);
                    transition: transform 0.3s ease;
                    z-index: 1001;
                    background-color: #fff;
                    box-shadow: 4px 0 10px rgba(0, 0, 0, 0.1); /* Right-side shadow */
                }
                    .sidebar-sub {
                        position: fixed;
                
                        left: 0px;
                        height: 100%;
                        width: 250px;
                        transform: translateX(-100%);
                        transition: transform 0.3s ease;
                        z-index: 1001;
                        background-color: #fff;
                    }

                    .sidebar-main.sidebar-visible {
                        transform: translateX(0);
                        z-index: 1100;
                    }
                    .sidebar-sub.sidebar-visible {
                        transform: translateX(0);
                        z-index: 1101;
                        left: 70px;

                    }

                    .sidebar-overlay {
                        display: block;
                        position: fixed;
                        top: 60;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background: rgba(0,0,0,0.35);
                        z-index: 1099;
                        transition: background 0.3s;
                    }
                }
            `}</style>
        </DashboardLayout>
    );
};

export default EventProfileDetailsPage;
